<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Return-Ticket-Invoice-Control')}} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="searchsatilanbilet"
                :label="$t('Search')"
                append-icon="search"
              ></v-text-field>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title
                      >Html {{ $t("Download") }}</v-list-tile-title
                    >
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title
                      >Excel {{ $t("Download") }}</v-list-tile-title
                    >
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>
              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex pb-3 xs12 sm12 md12>
                        <v-card flat>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp
                                :etiket="$t('Date')"
                                :detaygizle="false"
                                :rules="[
                                  (v) => !!v || $t('Please-select-a-date'),
                                ]"
                                v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.BaslangicTarih"
                                v-model="Rapor.BaslangicTarih"
                              ></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp
                                :etiket="$t('Date')"
                                :detaygizle="false"
                                :rules="[
                                  (v) => !!v || $t('Please-select-a-date'),
                                ]"
                                v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.BitisTarih"
                                v-model="Rapor.BitisTarih"
                              ></tarihcomp>
                            </v-flex>

                            <v-flex pt-2>
                              <v-layout align-center="">
                                <div v-if="load1">
                                  <v-btn
                                    color="info"
                                    @click="getList()"
                                    fab
                                    small=""
                                    dark
                                  >
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </div>
                                <div v-if="progress">
                                  <v-layout align-center="">
                                    <v-progress-circular
                                      indeterminate
                                      :width="4"
                                      color="blue"
                                    ></v-progress-circular>
                                  </v-layout>
                                </div>
                                <v-badge color="white" :overlap="true">
                                  <template v-slot:badge>
                                    <v-icon
                                      v-if="filtrevarmi"
                                      large
                                      color="green"
                                    >
                                      check_circle_outline
                                    </v-icon>
                                  </template>

                                  <v-btn
                                    small=""
                                    @mouseenter="tooltip = true"
                                    @mouseleave="tooltip = false"
                                    ref="fab"
                                    @click="filtrele()"
                                    color="info"
                                    fab
                                    dark
                                  >
                                    <v-icon>filter_list</v-icon>
                                  </v-btn>
                                  <v-tooltip
                                    bottom=""
                                    :activator="el"
                                    v-model="tooltip"
                                  >
                                    <span>{{ $t("Add-Search-Filter") }}</span>
                                  </v-tooltip>
                                </v-badge>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card>
              </v-flex>

              <v-flex xs12 v-if="kayitvarmi" sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table
                              :headers="headerRefund"
                              :rows-per-page-items="[20, 50, 100, 200]"
                              :items="itemRefund"
                              :search="searchsatilanbilet"
                            >
                              <template slot="items" slot-scope="props">
                                <td class="text-xs-left">
                                  {{ props.item.Tarih | dateformat }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.FaturaNo }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.CariKodu }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.HavayoluKodu }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.BiletNo }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.DekontNo }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.AcenteKodu }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.IadeAlanKisi }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.YolcuAdi }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.IadeFaturaTarihi | dateformat }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.IadeBelgeNo }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tip }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.Tutar }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.Ceza }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.Iskonto }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.Kdv }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.Yff }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.Ka }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.AlanTax }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.NetTutar }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.GelenIadeFaturaTutar }}
                                </td>
                                <td class="text-xs-left">
                                  {{ props.item.Tutarlar.IadeServis }}
                                </td>
                              </template>
                              <template v-slot:footer>
                                <td colspan="12"></td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.Tutar }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.Ceza }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.Iskonto }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.Kdv }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.Yff }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.Ka }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.AlanTax }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.NetTutar }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.GelenIadeFaturaTutar }}
                                </td>
                                <td class="text-xs-left">
                                  {{ itemRefundSum.IadeServis }}
                                </td>
                              </template>
                              <v-alert
                                slot="no-results"
                                :value="true"
                                color="error"
                                icon="warning"
                              >
                                {{
                                  $t("No-records-searched-for", {
                                    value: searchsatilanbilet,
                                  })
                                }}
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{
              $t("Close")
            }}</v-btn>
          </v-snackbar>

          <v-dialog
            v-model="dialogfiltre"
            scrollable=""
            persistent=""
            max-width="350px"
          >
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t("Filter-selection") }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-flex xs12 sm12 md12>
                              <v-radio-group
                                v-model="Rapor.UcusTipi"
                                :label="$t('Ticket-Type')"
                                column
                              >
                                <v-radio
                                  :label="$t('All')"
                                  :value="0"
                                ></v-radio>
                                <v-radio
                                  :label="$t('Domestic-Line')"
                                  :value="1"
                                ></v-radio>
                                <v-radio
                                  :label="$t('International-Line')"
                                  :value="2"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-radio-group
                                v-model="Rapor.RaporTip"
                                label="Rapor Tip"
                                column
                              >
                                <v-radio
                                  label="Iade Tarihine Göre"
                                  value="0"
                                ></v-radio>
                                <v-radio
                                  label="Iade Fatura Tarihine Göre"
                                  value="1"
                                ></v-radio>
                                <v-radio
                                  label="İşlem Tarihine Göre"
                                  value="2"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <cariaracomp
                                v-bind:etiket="'Cari Kod'"
                                :rules="true"
                                v-bind:value="Rapor.CariKod"
                                v-model="Rapor.CariKod"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox
                                v-model="Rapor.KdvAyir"
                                label="KDV Ayır"
                                hide-details=""
                              ></v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox
                                v-model="tumsirketler"
                                :label="$t('All-Companies')"
                                hide-details=""
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtreiptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtrekayit()"
                  >{{ $t("Apply-Filters") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      headerRefund: [
        {
          text: "Tarih",
        },
        {
          text: "Fatura No",
        },
        {
          text: "Cari Kodu",
        },
        {
          text: "Havayolu Kodu",
        },
        {
          text: "Bilet No",
        },
        {
          text: "Dekont No",
        },
        {
          text: "Acente Kodu",
        },
        {
          text: "Iade Alan Kişi",
        },
        {
          text: "Yolcu Adı",
        },
        {
          text: "Iade Fatura Tarihi",
        },
        {
          text: "Iade Belge No",
        },
        {
          text: "Tip",
        },
        {
          text: "Tutar",
        },
        {
          text: "Ceza",
        },
        {
          text: "Iskonto",
        },
        {
          text: "Kdv",
        },
        {
          text: "Yff",
        },
        {
          text: "Ka",
        },
        {
          text: "Alan Tax",
        },
        {
          text: "Net Tutar",
        },
        {
          text: "Gelen Iade Fat. Tutar",
        },
        {
          text: "Iade Servis",
        },
      ],
      itemRefundSum: {},
      itemRefund: [],
      filtrevarmi: false,
      kayitvarmi: false,
      search: "",
      searchsatilanbilet: null,
      Rapor: {
        BaslangicTarih: null,
        BitisTarih: null,
        UcusTipi: 0, //0 tumu  1 : İç Hat, 2 : Dış Hat
        CariKod: null,
        SirketKodu: null,
        KdvAyir: false,
        RaporTip: "0", // 0 : Iade Tarih , 1 : Iade Fatura Tarih , 2 : islem tarih
      },
      valid: true,
      tumsirketler: "",
      items: [],
      load: false,
      load1: true,
      dialogfiltre: false,
      progress: false,
      tooltip: false,
      el: null,
      yok: false,
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date"),
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date"),
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.el = this.$refs.fab.$el;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  components: {
    tarihcomp: tarihcomp,
    referansmerkezicomp,
    yuzdeinput,
    yetkidialog,
    cariaracomp,
  },
  watch: {},
  methods: {
    getList: getList,
    getListHtml: getListHtml,
    getListExcel: getListExcel,
    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
  },
};

function filtrele() {
  this.dialogfiltre = true;
}

function filtrekayit() {
  this.filtrevarmi = true;
  this.dialogfiltre = false;
  this.getList();
}

function filtreiptal() {
  this.filtrevarmi = false;
  this.dialogfiltre = false;
  this.Rapor.CariKod = null;
  this.Rapor.UcusTipi = 0;
  this.Rapor.KdvAyir = false;
  this.Rapor.RaporTip = 0;
  this.tumsirketler = "";
}

function getList() {
  if (this.$refs.formgunluksatis.validate()) {
    this.kayitvarmi = false;
    this.progress = true;
    this.load1 = false;
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    if (this.tumsirketler === true) {
      this.Rapor.SirketKodu = "0";
    } else {
      this.Rapor.SirketKodu = credentials.SirketKodu;
    }

    var params = this.Rapor;

    this.$http
      .post(auth.API_URL + "api/TicketReport/RefundRetunInvoiceList", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if (response.body.DatayList.length > 0) {
            this.kayitvarmi = true;
            this.itemRefund = response.body.DatayList;
            this.itemRefundSum = response.body.Toplamlar;
            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = this.$t("No-Records-Found");
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-RefundRetunInvoiceList";
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = "Service Unavailable-RefundRetunInvoiceList";
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }
        }
      );
  }
}

function getListHtml() {
  if (this.$refs.formgunluksatis.validate()) {
    this.kayitvarmi = false;
    this.progress = true;
    this.load1 = false;
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    var lang = localStorage.getItem('lang')
    if (this.tumsirketler === true) {
      this.Rapor.SirketKodu = "0";
    } else {
      this.Rapor.SirketKodu = credentials.SirketKodu;
    }

    var params = this.Rapor;

    this.$http
      .post(
        auth.API_URL + "api/TicketReport/RefundRetunInvoiceListHtml",
        params,
        {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        }
      )
      .then(
        (response) => {
          this.progress = false;
          this.load1 = true;
          var blob = new Blob([response.data], {
            type: "application/html",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('ReturnTicketInvoiceCheck') + ".html";
          link.click();
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }
        }
      );
  }
}

function getListExcel() {
  if (this.$refs.formgunluksatis.validate()) {
    this.kayitvarmi = false;
    this.progress = true;
    this.load1 = false;
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    var lang = localStorage.getItem('lang')
    if (this.tumsirketler === true) {
      this.Rapor.SirketKodu = "0";
    } else {
      this.Rapor.SirketKodu = credentials.SirketKodu;
    }

    var params = this.Rapor;

    this.$http
      .post(auth.API_URL + "api/TicketReport/RefundRetunInvoiceExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
        responseType: "arraybuffer",
      })
      .then(
        (response) => {
          this.progress = false;
          this.load1 = true;
          if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> İADE BİLET FATURA KONTROL </title>','<title> RETURN TICKET INVOICE CHECK </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>İADE BİLET FATURA KONTROL</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>RETURN TICKET INVOICE CHECK</font>")
             bodyhtml=bodyhtml.toString().replace("Hava Yolu Code :","Airline Code :")
             bodyhtml=bodyhtml.toString().replace("Bilet No :","Ticket No :")
             bodyhtml=bodyhtml.toString().replace("HY Kodu","Airline Code")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace("Uçuş Type","Flight Type")
             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")
             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")
             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")
             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")
             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")
             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")
            
             response.bodyText=bodyhtml;
             
          }
          var blob = new Blob([response.data], {
            type: "application/xlsx",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('ReturnTicketInvoiceCheck') + ".xlsx";
          link.click();
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = "Service Unavailable";
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }
        }
      );
  }
}

function beforeMount() {}
</script>

<style>
</style>